import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ManageBlogs.css";

const API_BASE = process.env.REACT_APP_API_URL || "https://api.goharesadaf.ir";

export default function ManageBlogs() {
  const [blogs, setBlogs] = useState([]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    const res = await fetch(`${API_BASE}/api/blogs`, {
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    const data = await res.json();
    setBlogs(data);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("آیا مطمئن هستید؟")) return;
    await fetch(`${API_BASE}/api/blogs/${id}`, {
      method: "DELETE",
      headers: { Authorization: token ? `Bearer ${token}` : "" },
    });
    setBlogs(blogs.filter((b) => b.id !== id));
  };

  return (
    <div className="manage-blogs-container">
      <h1 className="manage-blogs-title">مدیریت بلاگ‌ها</h1>

      {blogs.length === 0 ? (
        <p className="manage-blogs-empty">هیچ بلاگی وجود ندارد.</p>
      ) : (
        <table className="manage-blogs-table">
          <thead>
            <tr>
              <th>عنوان</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {blogs.map((blog) => (
              <tr key={blog.id}>
                <td>{blog.title}</td>
                <td>
                  <button
                    className="manage-blogs-btn edit-btn"
                    onClick={() => navigate(`/cms/edit-blog/${blog.id}`)}
                  >
                    ویرایش
                  </button>
                  <button
                    className="manage-blogs-btn delete-btn"
                    onClick={() => handleDelete(blog.id)}
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
